var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tiktok_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#9083E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.655 11.635a3.652 3.652 0 0 1-.318-.194 4.54 4.54 0 0 1-.816-.73 4.143 4.143 0 0 1-.92-1.999h.003c-.07-.432-.041-.712-.036-.712h-2.775v11.29c0 .15 0 .3-.006.449l-.002.055c0 .007 0 .017-.003.025v.007c-.029.405-.152.796-.358 1.139-.207.343-.49.627-.826.828-.35.21-.746.32-1.149.319-1.292 0-2.34-1.11-2.34-2.479 0-1.37 1.048-2.48 2.34-2.48.245 0 .489.041.721.121l.004-2.973a4.908 4.908 0 0 0-2.108.174 5.078 5.078 0 0 0-1.864 1.05c-.478.437-.88.958-1.188 1.54-.117.213-.559 1.068-.612 2.453-.034.786.19 1.602.298 1.938v.008c.067.197.328.874.753 1.445.343.458.748.86 1.202 1.193v-.007l.006.007c1.343.96 2.832.897 2.832.897.258-.011 1.121 0 2.102-.489 1.088-.542 1.707-1.35 1.707-1.35.395-.482.71-1.032.93-1.626a6.373 6.373 0 0 0 .334-1.86v-5.99c.034.02.483.333.483.333s.646.436 1.653.719c.722.202 1.696.245 1.696.245v-2.9c-.34.04-1.033-.073-1.743-.445Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tiktok_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h34v34H0z"
  })))));
};
export default SvgTiktok;